import { render, staticRenderFns } from "./playerprofile.vue?vue&type=template&id=f1db51c4&scoped=true"
import script from "./playerprofile.vue?vue&type=script&lang=js"
export * from "./playerprofile.vue?vue&type=script&lang=js"
import style0 from "./playerprofile.vue?vue&type=style&index=0&id=f1db51c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1db51c4",
  null
  
)

export default component.exports